import React, { ReactNode } from 'react'
import { T } from '@transifex/react'
import { TInquiryType } from './data'

export const mockInquiryTypeLabelMap: Record<TInquiryType, ReactNode> = {
  missorted_waste: <T _str="Missorted waste" />,
}
